<template>
	<div class="basis-page-cls">
        <section class="basis-cls_filter">
			<table-search :filterHeader="filterHeader" :defaultQuery="listQuery" @filterSearch="filterSearch" />
        </section>
        <section class="basis-cls_table">
            <div class="header">
                <span class="title el-icon-document"> 数据列表</span>
            </div>
            <div class="table">
				<el-table :data="list" :header-cell-class-name="tableHeaderClassName" :row-style="tableRowClassStyle" min-widht="180" ref="table" style="width: 100%;">
					<el-table-column label="方向">
						<template slot-scope="scope">
							{{['1', 'IB'].includes(scope.row.direction) ? '来访' : '出访'}}
						</template>
					</el-table-column>
					<el-table-column label="渠道" prop="channelId">
						<template slot-scope="scope">
							{{getChannelStatus(scope.row.channelId)}}
						</template>
					</el-table-column>
					<el-table-column label="客户ID" width="220">
						<template slot-scope="scope">
							<el-link @click.stop="handleCustomerInfo(scope.row)" type="primary">{{scope.row.custId}}</el-link>
						</template>
					</el-table-column>
					<el-table-column label="客户名称" prop="custName"></el-table-column>
					<el-table-column label="坐席名称" prop="csrUserName"></el-table-column>
					<el-table-column label="创建时间" prop="createdText" width="220"></el-table-column>
					<el-table-column label="操作" width="150">
						<template slot-scope="scope">
							<el-button type="text" @click="handleView(scope.row)">详情</el-button>
							<el-divider direction="vertical"></el-divider>
							<el-button v-if="scope.row.channelId == 'phone'" :disabled="!scope.row.custId" type="text" @click="toogleExpand(scope.row)">录音记录 <i :class="scope.row.expansion  ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i></el-button>
							<el-button v-else-if="scope.row.channelId == 'sms'" :disabled="!scope.row.custId" type="text" @click="toogleExpand(scope.row)">短信记录 <i :class="scope.row.expansion  ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i></el-button>
							<el-button v-else :disabled="!scope.row.custId" type="text" @click="toogleExpand(scope.row)">聊天记录 <i :class="scope.row.expansion  ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i></el-button>
						</template>
					</el-table-column>
					<el-table-column type="expand" width="1">
						<template slot-scope="scope">
							<Record v-if="scope.row.expansion" :row="scope.row" />
						</template>
					</el-table-column>
				</el-table>
				<template class="pagination">
					<Pagination 
						:total="total"
						:page.sync="listQuery.pageNumber"
						:limit.sync="listQuery.pageSize"
						@pagination="getList" />
				</template>
				
            </div>
        </section>

		<el-dialog :modal-append-to-body="false" title="详情" :close-on-press-escape="false" :close-on-click-modal="false" :visible.sync="dialogFormVisible" width="875px">
			<Info v-if="dialogFormVisible" sourceType="info" :row="row" @closeDialogFormVisible="handleCloseDialogFormVisible" />
		</el-dialog>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { EnumMixin, tableMixin } from "utils/mixins";
import Record from "./record";
import Info from "./info";
import Pagination from 'components/Basis/TablePagination/Pagination';
export default {
	name: 'CommunicatePageIndex',
	mixins: [EnumMixin, tableMixin],
	components: {Record, Info, Pagination},
	computed: {
        ...mapGetters([
			'userInfo',
			'subBrandList',
			'channelList'
        ])
    },
	watch: {
		$route: {
			handler(val){
				if(val?.query?.phone){
					this.listQuery.phone = this.$route?.query?.phone;
					this.getList();
				}
			},
			immediate: true,
			deep: true
		}
	},
	data() {
		return {
			filterHeader: [
				{ label: '子品牌', model: 'subBrandId', type: 'select', default: '', list: [] },
				{ label: '所属渠道', model: 'channelId', type: 'select', default: '', list: [] },
				{ label: '创建时间', model: 'date', type: 'datetimerange', default: '', placeholder: '请选择' },
				{ label: '沟通方向', model: 'direction', type: 'radioStyle', default: 'IB', list: [{name: '来访', id: 'IB'}, {name: '出访', id: 'OB'}]},
				{ label: '电话号码', model: 'phone', type: 'input', default: '', placeholder: '请输入电话号码' },
				{ label: '沟通ID', model: 'tuid', type: 'input', default: '', placeholder: '请输入沟通ID' }
			],
			listQuery: {
				pageSize: 10,
                pageNumber: 1,
				brandId: '',
				searchType: '',
				subBrandId: '',
				channelId: '',
				date: '',
				createdAfter: '',
				createdBefore: '',
				tuid: '',
				csrUserId: '',
				direction: 'IB',
				phone: '',
				custName: ''
            },
			total: 0,
			list: [],
			dialogFormVisible: false,
			row: {},
		}
	},
	async created() {
		await this.getList();
		await this.getDetailInfo();
		this.filterHeader[0]['list'] = await this.subBrandList;
		this.filterHeader[1]['list'] = await this.channelList;
	},
	methods: {
		getList() {
			if(this.listQuery.direction == 'IB') {
				this.listQuery.calledNumber = '';
				this.listQuery.callingNumber = this.listQuery.phone;
			} else {
				this.listQuery.callingNumber = '';
				this.listQuery.calledNumber = this.listQuery.phone;
			}
			this.listQuery.brandId = this.userInfo.brandIdentify;
			this.$api.apiPostCommunicateList(this.listQuery).then(response => {
				if(response.errcode != 0) return;
				this.list = response.data ? response.data : [];
				this.list.forEach(val => {
					this.$set(val, "expansion", false);
				});
				this.total = parseInt(response.total);
			});
		},
		handleCustomerInfo(row) {
			this.$router.push({name: 'customerInfo', params: {id: row.custId}});
		},
		getDetailInfo() {
			this.$api.apiQueryCommunicateColumn({brand: this.userInfo.brandIdentify}).then(response => {
				if(response.errcode != 0) return;
				const data = response.data;
				for(let i = 0; i < data.length; i++) {
					if(data[i]?.displayMode === 'input' && data[i]?.listQuery === 'Y') {
						this.filterHeader.push({
							label: data[i]?.columnName, model: data[i]?.columnKey, type: 'input', default: '', placeholder: `请输入${data[i]?.columnName}`
						});
					}
				}
			});
		},
		handleView(row) {
			this.row = row;
			this.dialogFormVisible = true;
		},
		handleCloseDialogFormVisible(row) {
			this.dialogFormVisible = false;
			if(row) this.getList();
		},
        filterSearch(query) {
			this.listQuery = Object.assign(this.listQuery, query);
            this.getList();
		},
		toogleExpand(row) {
			let $table = this.$refs.table;
			this.list.map(item => {
				if (row.tuid != item.tuid) {
					$table.toggleRowExpansion(item, false);
					item.expansion = false;
				} else {
					item.expansion = !item.expansion;
				}
			});
			$table.toggleRowExpansion(row);
		}
	}
}
</script>

<style lang="scss" scoped>
::v-deep .pagination-container{
	text-align: center;
}
</style>
